import classNames from 'clsx';
import React, { type CSSProperties, type PropsWithChildren, forwardRef } from 'react';
import { RemoveGroupButton } from 'reactApp/ui/Duplicates/RemoveGroupButton/RemoveGroupButton';
import { AdvBanner } from 'reactApp/ui/Mobile/Datalist/AdvBanner/AdvBanner';

import styles from './VirtualListDivider.css';

interface VirtualListDividerProps {
    itemClassName?: string;
    containerClassName?: string;
    style?: CSSProperties;
    adv?: boolean;
    qaId?: string;
    dividerSize?: string;
    duplicates?: boolean;
    duplicatesGroupId?: string;
}

export const VirtualListDivider = forwardRef<HTMLDivElement, PropsWithChildren<VirtualListDividerProps>>(function VirtualListDivider(
    { itemClassName, containerClassName, style, qaId, children, adv, dividerSize, duplicates, duplicatesGroupId },
    ref
) {
    return (
        <div
            className={classNames(containerClassName, styles.container, {
                [styles.adv]: adv,
                [styles.duplicates]: duplicates,
            })}
            style={style}
            data-qa-divider={qaId}
            ref={ref}
        >
            <div
                className={classNames(itemClassName, styles.root, {
                    [styles[`root_${dividerSize}`]]: !!dividerSize,
                })}
            >
                {children}
            </div>
            {adv && <AdvBanner />}
            {duplicates && <RemoveGroupButton groupId={duplicatesGroupId} />}
        </div>
    );
});
